$(function(){
    // TVC
    var $tvc = $('#tvc');
    if ($tvc.length) {
        function loadTvcIframe() {
            var $iframe = $('#tvc_video_max');
            if (!$iframe.length) return;
            var lazySrc = $iframe.attr('data-lazysrc');
            if (lazySrc && !$iframe.attr('src')) {
                $iframe.attr('src', lazySrc);
            }
        }

        if ($(window).width() > 1080) {
            $tvc.find('.tvc_youtube_video .youtube_video_content .close_btn').click(function () {
                $tvc.find('.tvc_youtube_video').hide();
            });
            $tvc.find('.tvc_playBox').click(function () {
                loadTvcIframe();
                $tvc.find('.tvc_youtube_video').show();
            });
        } else {
            $tvc.find('.tvc_youtube_video .youtube_video_content .close_btn').click(function () {
                $tvc.find('.tvc_youtube_video').animate({ top: '100vh', opacity: 0 }, 300);
            });
            $tvc.find('.tvc_playBox').click(function () {
                loadTvcIframe();
                $tvc.find('.tvc_youtube_video').animate({ top: '0', opacity: 1 }, 300);
            });
        }
    }







    // module5 swiper（ScrollTrigger 固定一屏 + 滚动切换）
    var module5Swiper = null;
    var module5ST = null;
    var module5FromScroll = false;
    var module5SlideCount = 0;
    var module5ScrollSlideIndex = 0;

    function syncModule5SlideToProgress(progress, immediate) {
        if (!module5Swiper || module5SlideCount <= 1) return;
        var index = Math.round(progress * (module5SlideCount - 1));
        index = Math.max(0, Math.min(module5SlideCount - 1, index));
        if (index === module5ScrollSlideIndex && !immediate) return;
        module5ScrollSlideIndex = index;
        module5FromScroll = true;
        module5Swiper.slideTo(index, immediate ? 0 : 600);
    }

    function refreshModule5Scroll() {
        if (!module5ST || typeof ScrollTrigger === 'undefined') return;
        if (module5Swiper) {
            module5Swiper.update();
        }
        ScrollTrigger.refresh(true);
        if (module5ST) {
            syncModule5SlideToProgress(module5ST.progress, true);
            module5FromScroll = false;
        }
    }

    function destroyModule5() {
        if (module5ST) {
            module5ST.kill();
            module5ST = null;
        }
        if (module5Swiper) {
            module5Swiper.destroy(true, true);
            module5Swiper = null;
        }
        module5SlideCount = 0;
        module5ScrollSlideIndex = 0;
    }

    function initModule5() {
        var wrap = document.querySelector('#FunBox3D .module5-scroll');
        var section = document.querySelector('#FunBox3D .module5-scroll > .module5');
        if (!wrap || !section || !document.querySelector('#module5-swiper')) return;

        destroyModule5();

        var hasGsap = typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined';
        var enableScrollPin = hasGsap;

        module5Swiper = new Swiper('#module5-swiper', {
            slidesPerView: 'auto',
            speed: 600,
            allowTouchMove: !enableScrollPin,
            spaceBetween: '16px',
            navigation: {
                nextEl: '#module5-swiper .swiper-button-next',
                prevEl: '#module5-swiper .swiper-button-prev',
            },
            breakpoints: {
                1081: {
                    spaceBetween: '16px%',
                },
                2560: {
                    spaceBetween: '16px',
                },
            },
        });

        if (!enableScrollPin) return;

        gsap.registerPlugin(ScrollTrigger);

        var slideCount = module5Swiper.slides.length;
        module5SlideCount = slideCount;
        if (slideCount <= 1) return;

        module5ScrollSlideIndex = 0;

        module5ST = ScrollTrigger.create({
            trigger: wrap,
            pin: section,
            start: 'top top',
            end: function () {
                return '+=' + (slideCount - 1) * window.innerHeight;
            },
            pinSpacing: true,
            anticipatePin: 1,
            invalidateOnRefresh: true,
            snap: {
                snapTo: 1 / (slideCount - 1),
                duration: { min: 0.2, max: 0.5 },
                delay: 0,
            },
            onUpdate: function (self) {
                var index = Math.round(self.progress * (slideCount - 1));
                index = Math.max(0, Math.min(slideCount - 1, index));
                if (index === module5ScrollSlideIndex) return;
                module5ScrollSlideIndex = index;
                module5FromScroll = true;
                module5Swiper.slideTo(index, module5Swiper.animating ? 0 : 600);
            },
            onRefresh: function (self) {
                if (!self.isActive) return;
                syncModule5SlideToProgress(self.progress, true);
                module5FromScroll = false;
            },
            onEnter: function (self) {
                syncModule5SlideToProgress(self.progress, true);
                module5FromScroll = false;
            },
            onEnterBack: function (self) {
                syncModule5SlideToProgress(self.progress, true);
                module5FromScroll = false;
            },
        });

        module5Swiper.on('slideChangeTransitionEnd', function () {
            module5FromScroll = false;
        });

        module5Swiper.on('slideChange', function () {
            if (module5FromScroll || !module5ST) return;
            module5ScrollSlideIndex = module5Swiper.activeIndex;
            var progress = module5Swiper.activeIndex / (slideCount - 1);
            var targetScroll = module5ST.start + progress * (module5ST.end - module5ST.start);
            window.scrollTo({ top: targetScroll, behavior: 'smooth' });
        });

        syncModule5SlideToProgress(module5ST.progress, true);
        module5FromScroll = false;
    }

    var module5ResizeTimer;
    $(window).on('resize.module5', function () {
        clearTimeout(module5ResizeTimer);
        module5ResizeTimer = setTimeout(refreshModule5Scroll, 200);
    });




    // 瀑布流js
    // 用设计稿坐标算列高（与容器像素无关），保证本地 / Shopify 选列结果一致
    // PC 期望：1.11.14 | 2.8 | 3.10 | 4.7.12 | 5.13 | 6.9
    function initWaterfall() {
        var wrapper = $('.waterfall-wrapper');
        var itemsSource = $('.waterfall-items');
        if (!wrapper.length || !itemsSource.length) return;

        var items = itemsSource.find('.waterfall-item').clone();
        var isMobile = $(window).width() <= 1080;
        var columns = isMobile ? 3 : 6;
        var designBase = isMobile ? 1080 : 2160;

        var wrapperWidth = wrapper.width();
        if (!wrapperWidth) {
            clearTimeout(initWaterfall._retryTimer);
            initWaterfall._retryTimer = setTimeout(initWaterfall, 100);
            return;
        }

        wrapper.empty();

        // PC: [220, 80, 140, 0, 120, 220] / 移动端: [294, 0, 265]
        var colPaddings = isMobile
            ? [294, 0, 265]
            : [220, 80, 140, 0, 120, 220];
        var gapDesign = 18;
        // 设计稿下列宽（与图片 width 属性同一套坐标系）
        var colDesignWidth = isMobile ? 226 : 338;

        var colElements = [];
        for (var i = 0; i < columns; i++) {
            var col = $('<div class="waterfall-col" data-col="' + i + '"></div>');
            col.css({
                'padding-top': ((colPaddings[i] / designBase) * wrapperWidth) + 'px',
                'min-width': 0
            });
            colElements.push(col);
            wrapper.append(col);
        }

        items.each(function () {
            var img = $(this).find('img');
            var imgWidth = parseInt(img.attr('width'), 10) || 338;
            var imgHeight = parseInt(img.attr('height'), 10) || 338;
            img.css('aspect-ratio', imgWidth + ' / ' + imgHeight);
        });

        function getItemDesignHeight(item) {
            var img = item.find('img');
            var imgWidth = parseInt(img.attr('width'), 10) || 338;
            var imgHeight = parseInt(img.attr('height'), 10) || 338;
            return imgHeight * (colDesignWidth / imgWidth) + gapDesign;
        }

        var heights = [];
        var firstBatchCount = isMobile ? 3 : 6;
        for (var c = 0; c < columns; c++) {
            heights[c] = colPaddings[c];
        }

        // 前 N 张按列顺序放入
        for (var i = 0; i < Math.min(firstBatchCount, items.length); i++) {
            var item = items.eq(i);
            colElements[i].append(item);
            heights[i] += getItemDesignHeight(item);
        }

        // 第 N+1 张起插入当前设计高度最短的列（纯计算，不读 DOM）
        for (var i = firstBatchCount; i < items.length; i++) {
            var item = items.eq(i);
            var targetColIndex = 0;
            for (var j = 1; j < columns; j++) {
                if (heights[j] < heights[targetColIndex]) targetColIndex = j;
            }
            colElements[targetColIndex].append(item);
            heights[targetColIndex] += getItemDesignHeight(item);
        }

        observeWaterfallLazyImages();
    }

    var waterfallLazyObserver = null;

    function getWaterfallLazyObserver() {
        if (waterfallLazyObserver) return waterfallLazyObserver;
        if (typeof IntersectionObserver === 'undefined') return null;
        waterfallLazyObserver = new IntersectionObserver(function (entries, obs) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                var element = entry.target;
                var dataSrc = element.getAttribute('data-lazysrc');
                if (dataSrc) element.setAttribute('src', dataSrc);
                obs.unobserve(element);
                if (element.tagName === 'IMG') {
                    element.onload = function () {
                        element.setAttribute('style', 'aspect-ratio: auto ' + element.naturalWidth + ' / ' + element.naturalHeight);
                    };
                }
            });
        });
        return waterfallLazyObserver;
    }

    function observeWaterfallLazyImages() {
        var observer = getWaterfallLazyObserver();
        var selector = 'img.lazy-2nd, video.lazy-2nd, iframe.lazy-2nd, source.lazy-2nd';
        $('.waterfall-wrapper').find(selector).each(function () {
            if (this.getAttribute('src')) return;
            if (observer) {
                observer.observe(this);
            } else {
                var dataSrc = this.getAttribute('data-lazysrc');
                if (dataSrc) this.setAttribute('src', dataSrc);
            }
        });
    }
    
    // vm 单位转换函数
    function vm(px) {
        return (px / 2160) * 100 + 'vw';
    }
    
    // 确保在DOM完全加载后再初始化
    $(window).on('load', function() {
        if ($('.waterfall-wrapper').length) {
            initWaterfall();
        }
        if (document.querySelector('#FunBox3D .module5-scroll')) {
            initModule5();
            refreshModule5Scroll();
        }
        if (document.querySelector('#FunBox3D .module6')) {
            initModule6Animation();
        }
        if (document.querySelector('#FunBox3D .module11')) {
            initModule11Animation();
        }
        setTimeout(function () {
            if ($('.waterfall-wrapper').length) {
                initWaterfall();
            }
            refreshModule6Scroll();
            if (document.querySelector('#FunBox3D .module11')) {
                initModule11Animation();
            }
        }, 300);
    });
    
    // 防抖处理 resize
    var resizeTimer;
    $(window).resize(function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            if ($('.waterfall-wrapper').length) {
                initWaterfall();
            }
            refreshModule5Scroll();
            refreshModule6Scroll();
            if (document.querySelector('#FunBox3D .module11')) {
                initModule11Animation();
            }
        }, 200);
    });






    // module9
    function isModule9Mobile() {
        return $(window).width() <= 1080;
    }

    function switchModule9ByIndex(index) {
        var $left = $('#FunBox3D .module9 .text-content .left');
        var $right = $('#FunBox3D .module9 .text-content .right');
        var $items = $left.find('.sp-item');
        var count = $items.length;

        if (!count) return;

        index = ((index % count) + count) % count;

        var $item = $items.eq(index);
        if ($item.hasClass('active')) {
            return;
        }

        if (isModule9Mobile()) {
            $left.find('.sp-item').removeClass('active');
            $item.addClass('active');
            $right.find('.sp-item').removeClass('active').eq(index).addClass('active');
        } else {
            $left.find('.sp-item').not($item).removeClass('active')
                .find('.display-feature__desc3').stop(true, true).slideUp(250);
            $item.addClass('active')
                .find('.display-feature__desc3').stop(true, true).slideDown(250);
            $right.find('.sp-item').removeClass('active').eq(index).addClass('active');
        }

        $right.find('.sp-item').each(function (i) {
            var video = $(this).find('video').get(0);
            if (!video) return;
            if (i === index) {
                video.play().catch(function () {});
            } else {
                video.pause();
            }
        });
    }

    function switchModule9Item($item) {
        switchModule9ByIndex($item.index());
    }

    function initModule9() {
        var $module9 = $('#FunBox3D .module9');
        if (!$module9.length) return;

        var $module9Left = $module9.find('.text-content .left');
        if (!$module9Left.length) return;

        $module9Left.off('.module9');
        $module9.find('.text-content .arrow_box .button-prev').off('.module9');
        $module9.find('.text-content .arrow_box .button-next').off('.module9');

        $module9Left.on('mouseenter.module9', '.sp-item', function () {
            if (isModule9Mobile()) return;
            switchModule9Item($(this));
        });

        $module9.find('.text-content .arrow_box .button-prev').on('click.module9', function () {
            if (!isModule9Mobile()) return;
            var currentIndex = $module9Left.find('.sp-item.active').index();
            switchModule9ByIndex(currentIndex - 1);
        });

        $module9.find('.text-content .arrow_box .button-next').on('click.module9', function () {
            if (!isModule9Mobile()) return;
            var currentIndex = $module9Left.find('.sp-item.active').index();
            switchModule9ByIndex(currentIndex + 1);
        });

        if (!isModule9Mobile()) {
            $module9Left.find('.sp-item').not('.active').find('.display-feature__desc3').hide();
            $module9Left.find('.sp-item.active').find('.display-feature__desc3').show();
        }
    }

    initModule9();




    // module11
    var module11PosimgOpacityDuration = 1; // module11-posimg 透明度动画时长（秒）
    var module11Timeline = null;
    var module11EnterST = null;
    var module11ResetST = null;
    var module11ScrollEnabled = false;

    function isModule11Enabled() {
        return typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined';
    }

    function shouldModule11PlayNow(module11) {
        var rect = module11.getBoundingClientRect();
        return rect.bottom <= window.innerHeight + 2 && rect.top < window.innerHeight;
    }

    function syncModule11EnterState(module11) {
        if (!module11EnterST || !module11Timeline) return;
        if (shouldModule11PlayNow(module11)) {
            module11Timeline.restart();
            destroyModule11EnterST();
        }
    }

    function refreshModule11Scroll() {
        if (!module11ScrollEnabled || typeof ScrollTrigger === 'undefined') return;
        ScrollTrigger.refresh(true);
        var module11 = document.querySelector('#FunBox3D .module11');
        if (module11) {
            syncModule11EnterState(module11);
        }
    }

    function setModule11MobileState(module11Text, module11Posimg) {
        if (typeof gsap === 'undefined') return;
        gsap.set(module11Text, { xPercent: -50, y: 0 });
        gsap.set(module11Posimg, { opacity: 1 });
    }

    function resetModule11Animation(module11Text, module11Posimg) {
        if (module11Timeline) {
            module11Timeline.progress(0).pause();
        }
        if (typeof gsap === 'undefined') return;
        var module11TextHeight = module11Text.offsetHeight;
        gsap.set(module11Text, { xPercent: -50, y: module11TextHeight });
        gsap.set(module11Posimg, { opacity: 0 });
    }

    function destroyModule11EnterST() {
        if (module11EnterST) {
            module11EnterST.kill();
            module11EnterST = null;
        }
    }

    function createModule11EnterST(module11) {
        destroyModule11EnterST();
        module11EnterST = ScrollTrigger.create({
            trigger: module11,
            start: 'bottom bottom',
            onEnter: function () {
                module11Timeline.restart();
                destroyModule11EnterST();
            },
        });
    }

    function destroyModule11Animation() {
        destroyModule11EnterST();
        if (module11ResetST) {
            module11ResetST.kill();
            module11ResetST = null;
        }
        if (module11Timeline) {
            module11Timeline.kill();
            module11Timeline = null;
        }
        module11ScrollEnabled = false;
    }

    function initModule11Animation() {
        var module11 = document.querySelector('#FunBox3D .module11');
        var module11Text = document.querySelector('#FunBox3D .module11 .module11-text');
        var module11Posimg = document.querySelector('#FunBox3D .module11 .module11-posimg');
        if (!module11 || !module11Text || !module11Posimg) return;

        destroyModule11Animation();

        if (!isModule11Enabled()) {
            return;
        }

        module11ScrollEnabled = true;
        gsap.registerPlugin(ScrollTrigger);
        resetModule11Animation(module11Text, module11Posimg);

        module11Timeline = gsap.timeline({ paused: true })
            .to(module11Text, {
                y: 0,
                duration: 0.8,
                ease: 'power2.out',
            })
            .to(module11Posimg, {
                opacity: 1,
                duration: module11PosimgOpacityDuration,
                ease: 'power2.out',
            });

        createModule11EnterST(module11);

        module11ResetST = ScrollTrigger.create({
            trigger: module11,
            start: 'top bottom',
            onLeaveBack: function () {
                resetModule11Animation(module11Text, module11Posimg);
                createModule11EnterST(module11);
            },
        });

        ScrollTrigger.refresh(true);
        syncModule11EnterState(module11);
    }

    var module11ResizeTimer;
    $(window).on('resize.module11', function () {
        clearTimeout(module11ResizeTimer);
        module11ResizeTimer = setTimeout(function () {
            refreshModule11Scroll();
        }, 200);
    });










    // module12
    var module12Swiper = null;

    function destroyModule12() {
        if (module12Swiper) {
            module12Swiper.destroy(true, true);
            module12Swiper = null;
        }
    }

    function initModule12() {
        if (!document.querySelector('#module12-swiper')) return;

        destroyModule12();

        module12Swiper = new Swiper('#module12-swiper', {
            slidesPerView: 'auto',
            spaceBetween: '16px',
            speed: 600,
            navigation: {
                nextEl: '#module12-swiper .swiper-button-next',
                prevEl: '#module12-swiper .swiper-button-prev',
            },
            breakpoints: {
                1081: {
                    spaceBetween: '16px',
                },
                2560: {
                    spaceBetween: '16px',
                },
            },
        });
    }

    initModule12();















    // module6js 代码开始
    var module6Timeline = null;
    var MODULE6_ANIM_STEPS = 10;

    function getModule6Elements() {
        var gaspBox = document.querySelector('#FunBox3D .module6 > .gasp-box');
        if (!gaspBox) return null;

        var els = {
            gaspBox: gaspBox,
            img1: gaspBox.querySelector('.gasp-box-img-1'),
            img1Text: gaspBox.querySelector('.gasp-box-img-1-text'),
            img2: gaspBox.querySelector('.gasp-box-img-2'),
            img3: gaspBox.querySelector('.gasp-box-img-3'),
            img4: gaspBox.querySelector('.gasp-box-img-4'),
            img5: gaspBox.querySelector('.gasp-box-img-5'),
            img3Text: gaspBox.querySelector('.gasp-box-img-3-text'),
            img4Text: gaspBox.querySelector('.gasp-box-img-4-text'),
            img5Text: gaspBox.querySelector('.gasp-box-img-5-text'),
        };

        for (var key in els) {
            if (key !== 'gaspBox' && !els[key]) return null;
        }

        return els;
    }

    function setModule6InitialState(els) {
        if (typeof gsap === 'undefined' || !els) return;
        gsap.set(els.img1, { autoAlpha: 1 });
        gsap.set(els.img1Text, { autoAlpha: 1 });
        gsap.set([els.img2, els.img3, els.img4, els.img5], { autoAlpha: 0 });
        gsap.set([els.img3Text, els.img4Text, els.img5Text], { autoAlpha: 0 });
    }

    function destroyModule6Animation() {
        if (module6Timeline) {
            module6Timeline.scrollTrigger && module6Timeline.scrollTrigger.kill();
            module6Timeline.kill();
            module6Timeline = null;
        }
    }

    function refreshModule6Scroll() {
        if (!module6Timeline || !module6Timeline.scrollTrigger || typeof ScrollTrigger === 'undefined') return;
        ScrollTrigger.refresh(true);
    }

    function initModule6Animation() {
        destroyModule6Animation();

        var els = getModule6Elements();
        if (!els) return;

        var hasGsap = typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined';

        if (!hasGsap) {
            return;
        }

        gsap.registerPlugin(ScrollTrigger);
        setModule6InitialState(els);

        module6Timeline = gsap.timeline({
            defaults: { duration: 1, ease: 'none' },
            scrollTrigger: {
                trigger: els.gaspBox,
                pin: true,
                start: 'top top',
                end: function () {
                    return '+=' + (MODULE6_ANIM_STEPS * window.innerHeight);
                },
                pinSpacing: true,
                scrub: 0.5,
                anticipatePin: 1,
                invalidateOnRefresh: true,
            },
        })
            .to(els.img1Text, { autoAlpha: 0 })
            .to(els.img1, { autoAlpha: 0 })
            .to(els.img2, { autoAlpha: 1 }, '<')
            .to(els.img3, { autoAlpha: 1 })
            .to(els.img3Text, { autoAlpha: 1 })
            .to(els.img3Text, { autoAlpha: 0 })
            .to(els.img3, { autoAlpha: 0 })
            .to(els.img4, { autoAlpha: 1 }, '<')
            .to(els.img4Text, { autoAlpha: 1 })
            .to(els.img4Text, { autoAlpha: 0 })
            .to(els.img4, { autoAlpha: 0 })
            .to(els.img2, { autoAlpha: 0 }, '<')
            .to(els.img5, { autoAlpha: 1 }, '<')
            .to(els.img5Text, { autoAlpha: 1 });

        ScrollTrigger.refresh(true);
    }

    var module6ResizeTimer;
    $(window).on('resize.module6', function () {
        clearTimeout(module6ResizeTimer);
        module6ResizeTimer = setTimeout(refreshModule6Scroll, 200);
    });
    // module6js 代码结束
})
